// extracted by mini-css-extract-plugin
export default {"chip":"chips_chip__XWRGp","chip_label":"chips_chip_label__Dnjjo","chip_close":"chips_chip_close__AVZrr"};